export type MissionEmojiCategory = {
  key: string
  emojis: string[]
}

export const MISSION_EMOJI_CATEGORIES: MissionEmojiCategory[] = [
  {
    key: 'rewards',
    emojis: [
      '🎁',
      '🏆',
      '🥇',
      '🥈',
      '🥉',
      '🎖️',
      '🏅',
      '👑',
      '💎',
      '⭐',
      '🌟',
      '✨',
      '🎀',
      '🎊',
      '🎉',
      '🪅',
      '🧧',
      '🍀',
      '🔮',
      '🪄'
    ]
  },
  {
    key: 'points',
    emojis: [
      '💰',
      '🪙',
      '💵',
      '💶',
      '💷',
      '💸',
      '🏷️',
      '🔖',
      '🎫',
      '🎟️',
      '🧾',
      '📈',
      '📊',
      '💳',
      '🛒',
      '🛍️',
      '💹',
      '➕',
      '🔢',
      '💯'
    ]
  },
  {
    key: 'profile',
    emojis: [
      '🧑',
      '👤',
      '👋',
      '🙋',
      '🙌',
      '🤝',
      '📝',
      '📋',
      '🪪',
      '📇',
      '🔐',
      '🔑',
      '📱',
      '✉️',
      '📮',
      '🎂',
      '🎈',
      '🥳',
      '😊',
      '🫶'
    ]
  },
  {
    key: 'engagement',
    emojis: [
      '💬',
      '🗨️',
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '👍',
      '👏',
      '📣',
      '📢',
      '🗳️',
      '📸',
      '🎥',
      '🎬',
      '🎤',
      '🎧',
      '🔔',
      '📌'
    ]
  },
  {
    key: 'shop',
    emojis: [
      '🏪',
      '🏬',
      '🏢',
      '🚪',
      '📍',
      '🗺️',
      '🕒',
      '📅',
      '🗓️',
      '🚚',
      '📦',
      '🧺',
      '♻️',
      '🌱',
      '🌍',
      '💡',
      '🧑‍🍳',
      '🧹',
      '🪑',
      '🚲'
    ]
  },
  {
    key: 'food',
    emojis: [
      '☕',
      '🍵',
      '🧋',
      '🥤',
      '🍺',
      '🍷',
      '🥐',
      '🍞',
      '🥖',
      '🧁',
      '🍰',
      '🍪',
      '🍩',
      '🍫',
      '🍦',
      '🍔',
      '🍟',
      '🍕',
      '🌮',
      '🥗'
    ]
  },
  {
    key: 'events',
    emojis: [
      '🎪',
      '🎭',
      '🎼',
      '🎸',
      '🪩',
      '🕺',
      '💃',
      '🎆',
      '🎇',
      '🥂',
      '🍾',
      '🎯',
      '🎲',
      '🎮',
      '🕹️',
      '🎳',
      '⚽',
      '🏀',
      '🎾',
      '🏓'
    ]
  }
]
